import React from 'react'

const Footer = () => {
    let footerStyle = {
        position: "absolute",
        bottom: '1rem',
        width: "100%",
        fontSize: '1.2rem',
        color: 'grey',
        fontFamily: 'verdana',
    }
    return (
        <>
            <div style={footerStyle} align="center">
                <footer className="center">
                    Copyright &copy; 2022 Bikash Jena
                </footer>
            </div>
        </>
    )
}

export default Footer